import {
  CardMedia,
  ImageListItem,
  ImageListItemBar,
  styled,
} from '@mui/material';

export const ResourceSelectorSidebarItemContainer = styled(ImageListItem)(
  ({ theme, $isSelected }) => `
  border: ${
    $isSelected
      ? `2px solid ${theme.palette.primary.main}`
      : `2px solid ${theme.palette.secondary.lighter}`
  };
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    border: 2px solid ${theme.palette.primary.main};
  }
`,
);

export const ResourceSelectorSidebarItemPreview = styled(CardMedia)`
  min-height: 50px;
  margin-bottom: 20px;
  object-fit: contain;
  -webkit-user-drag: none;
`;

export const ResourceSelectorSidebarItemTitle = styled(ImageListItemBar)(
  ({ theme }) => `
  & .MuiImageListItemBar-titleWrap {
    position: absolute;
    bottom: 0;
    background-color: ${theme.palette.secondary.lighter};
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 0;
  }

  & .MuiTypography-body2 {
    font-weight: 300;
  }
`,
);
